import React from 'react'

interface ExternalProps {
    pageTitle: string
}

export const withPageTitle = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps>,
) => {

    type ResultProps = OriginalProps & ExternalProps;

    return class extends React.Component<ResultProps> {
        static displayName: string = `withPageTitle(${WrappedComponent.displayName})`;

        componentDidMount(): void {
            document.title = this.props.pageTitle
        }

        render(): JSX.Element {
            return <WrappedComponent {...this.props} />
        }
    }
};
